// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"bw_gn","list":"bw_cC","link":"bw_cn","title":"bw_p","externalLink":"bw_hf","description":"bw_h","actions":"bw_g8","body":"bw_dv","actionLink":"bw_hg"};